import { Box } from "@mui/material";
import { getTranslation } from "common";
import { useTranslations } from "hooks";
import React from "react";
import { safeHtml } from "utils/safeHtml";

const PrivacyAndPolicy = () => {
  const translations = useTranslations();

  return (
    <React.Fragment>
      <Box
        dangerouslySetInnerHTML={{
          __html: safeHtml(
            getTranslation(translations, "register.content.privacy_policy")
          ),
        }}
      />
    </React.Fragment>
  );
};

export default PrivacyAndPolicy;
